/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmFeatureUsageRoute } from '@jira/router-routes__products-jsm-feature-usage-routes/src/productsJsmFeatureUsageRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ProductsJsmFeatureUsage, { LazyProductsJsmFeatureUsage } from './ui/index.tsx';

export const productsJsmFeatureUsageRouteEntry: Route = createEntry(
	productsJsmFeatureUsageRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJsmFeatureUsage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			workspaceResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProductsJsmFeatureUsage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
